import { getBaseUrl, useDatabaseContent } from '@databases/database-state';
import { defaultStoreUtils } from '@databases/redux';
import { DatabaseView, ViewId } from '@databases/types/database/view';
import { copyHtmlToClipboard } from '@databases/utils/copy-paste';
import { selectDatabaseByContentIdRequired } from '@databases/utils/redux/databases/selectors';
import { getDatabasePath } from '@databases/utils/urls';
import { useCallback } from 'react';

const useCopyViewLink = (contentId: string) => {
  const { unsavedViewId } = useDatabaseContent();
  const databasePath = defaultStoreUtils.useEqualSelector((state) => {
    const database = selectDatabaseByContentIdRequired(state, { contentId });
    return getDatabasePath(database);
  });

  const baseUrl = getBaseUrl();

  return useCallback(
    (view: DatabaseView) => {
      const url = new URL(baseUrl + databasePath);
      url.searchParams.set('savedViewId', view.id);

      if (view.id === ViewId.UNSAVED && unsavedViewId) {
        url.searchParams.set('unsavedView', unsavedViewId);
      } else {
        url.searchParams.delete('unsavedView');
      }
      return copyHtmlToClipboard(url.toString());
    },
    [baseUrl, databasePath, unsavedViewId]
  );
};

export default useCopyViewLink;
